import useSWR from 'swr';
import type { SwrReturnType } from '~/models/Api';
import type { DealConstructionItem } from '~/models/DealConstructionItem';
import { generatePath } from '~/utils/generatePath';

const buildPathWithQueryParams = (dealId: number): string => {
  const basePath = generatePath(
    '/vendors/deals/:deal_id/deal_construction_items',
    { deal_id: dealId }
  );
  const params = new URLSearchParams({ version: 'v2' });
  return `${basePath}?${params.toString()}`;
};

export const useDealConstructionItems = (
  dealId: number | null
): SwrReturnType<DealConstructionItem[]> => {
  const path = dealId ? buildPathWithQueryParams(dealId) : null;

  const { data, mutate, error, isLoading } =
    useSWR<DealConstructionItem[]>(path);

  return {
    data: data ?? null,
    mutate,
    isLoading,
    error
  };
};
